import { apiClient } from './client';
import { createCrudApi } from './crud';
import type { ApiSuccess } from '../types';

export interface WoItem { id?: number; labourRateId?: number | null; description: string; unit: string; quantity: number; rate: number; amount?: number; remarks?: string | null }
export interface WorkOrder {
  id: number; code: string; omsId: number; siteId: number | null; vendorId: number | null; technicianId: number | null;
  title: string; scopeOfWork: string | null; status: string; totalAmount: number; startDate: string | null;
  completionDate: string | null; percentComplete: number; items?: WoItem[]; createdAt: string;
}
export interface CreateWoInput {
  omsId: number; siteId?: number | null; vendorId?: number | null; technicianId?: number | null;
  title: string; scopeOfWork?: string; startDate?: string; items: WoItem[];
}
export interface WoDashboard { byStatus: Record<string, number>; totalValue: number }

const base = createCrudApi<WorkOrder, CreateWoInput>('work-orders');

export const workOrdersApi = {
  ...base,
  async dashboard(): Promise<WoDashboard> {
    const { data } = await apiClient.get<ApiSuccess<WoDashboard>>('/work-orders/dashboard');
    return data.data;
  },
  async changeStatus(id: number, action: string, remarks?: string) {
    const { data } = await apiClient.post<ApiSuccess<WorkOrder>>(`/work-orders/${id}/status`, { action, remarks });
    return data.data;
  },
};
